import { style } from '@vanilla-extract/css';

export const productEmbedContainer = style({
  padding: 'var(--wt-padding)',
});

export const imageContainer = style({
  marginBottom: '24px',
  width: 'var(--product-embed-image-width, 252px)',
  aspectRatio: '16 / 9',
  borderRadius: '8px',
  overflow: 'hidden',
});

export const contentContainer = style({
  color: '#272A2F',
  marginBottom: '24px',
});

export const title = style({
  color: '#272A2F',
  fontSize: '25px',
  fontWeight: 700,
  lineHeight: 'normal',
  marginBottom: '16px',
});

export const description = style({
  color: '#272A2F',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  wordBreak: 'break-word',
});

export const button = style({
  display: 'block',
  textAlign: 'center',
  width: 'var(--product-embed-button-width, fit-content)',
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingTop: '12px',
  paddingBottom: '12px',
  cursor: 'pointer',
  background: '#000000',
  borderRadius: '25px',
  color: '#ffffff',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  textDecoration: 'none',
  textTransform: 'uppercase',
});
